import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import API_BASE_URL from "../../config/api";
import { PageHeader } from "../ui";

const Login = ({ onLogin }) => {
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [resetFormData, setResetFormData] = useState({
    email: "",
    currentPassword: "",
    newPassword: "",
    confirmNewPassword: "",
  });
  const [error, setError] = useState("");
  const [resetError, setResetError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);
  const [resetLoading, setResetLoading] = useState(false);
  const [showResetForm, setShowResetForm] = useState(false);

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleResetChange = (e) => {
    setResetFormData({
      ...resetFormData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const response = await axios.post(`${API_BASE_URL}/auth/login`, formData);
      const { token, user } = response.data;
      onLogin(user, token);
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred during login");
    } finally {
      setLoading(false);
    }
  };

  const handleResetSubmit = async (e) => {
    e.preventDefault();
    setResetError("");
    setSuccess("");
    setResetLoading(true);

    try {
      const token = localStorage.getItem("token");
      const response = await axios.post(
        `${API_BASE_URL}/auth/reset-password`,
        resetFormData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setSuccess("Password reset successfully!");
      setResetFormData({
        currentPassword: "",
        newPassword: "",
        confirmNewPassword: "",
      });
      setTimeout(() => {
        setShowResetForm(false);
        setSuccess("");
      }, 2000);
    } catch (err) {
      setResetError(
        err.response?.data?.message || "An error occurred during password reset"
      );
    } finally {
      setResetLoading(false);
    }
  };

  const toggleResetForm = () => {
    setShowResetForm(!showResetForm);
    setResetError("");
    setSuccess("");
    setResetFormData({
      currentPassword: "",
      newPassword: "",
      confirmNewPassword: "",
    });
  };

  return (
    <div className="min-vh-100 d-flex flex-column">
      {/* Header */}
      <header className="mb-4">
        <PageHeader title="AI Calling Agent" className="auth-header" />
      </header>

      {/* Main Content */}
      <main className="flex-grow-1 d-flex justify-content-center align-items-center">
        <div className="w-100" style={{ maxWidth: "350px" }}>
          <div className="text-center mb-4">
            <h2 className="fw-bold">Welcome to AI Calling Agent Platform</h2>
            <div className="d-flex align-items-center my-4">
              <hr className="flex-grow-1" />
              <span className="mx-3 text-muted">sign in to your</span>
              <hr className="flex-grow-1" />
            </div>
          </div>

          {error && <div className="alert alert-danger">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          {/* Login Form */}
          {!showResetForm ? (
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label fw-semibold">Email Address</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">Password</label>
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  placeholder="Enter your password"
                  value={formData.password}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* <div className="d-flex justify-content-between align-items-center mb-3">
                <button
                  type="button"
                  className="btn btn-link p-0 text-primary"
                  onClick={toggleResetForm}
                >
                  Forgot Password?
                </button>
              </div> */}

              <button
                type="submit"
                className="btn btn-primary w-100 py-2"
                style={{ height: '50px', fontSize: '1.1rem' }}
                disabled={loading}
              >
                {loading ? "Signing in..." : "Sign In"}
              </button>

              {/* <div className="text-center mt-4">
                <p className="text-muted mb-0">
                  don't have a account?{" "}
                  <Link to="/signup" className="text-primary fw-medium">
                    Create an account
                  </Link>
                </p>
              </div> */}
            </form>
          ) : (
            <form onSubmit={handleResetSubmit}>
              <h5 className="fw-semibold mb-3">Reset Password</h5>

              {resetError && (
                <div className="alert alert-danger">{resetError}</div>
              )}

              <div className="mb-3">
                <label className="form-label fw-semibold">Email Address</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                  value={resetFormData.email}
                  onChange={handleResetChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">
                  Current Password
                </label>
                <input
                  type="password"
                  name="currentPassword"
                  className="form-control"
                  placeholder="Enter your current password"
                  value={resetFormData.currentPassword}
                  onChange={handleResetChange}
                  required
                />
              </div>

              <div className="mb-3">
                <label className="form-label fw-semibold">New Password</label>
                <input
                  type="password"
                  name="newPassword"
                  className="form-control"
                  placeholder="Enter your new password"
                  value={resetFormData.newPassword}
                  onChange={handleResetChange}
                  required
                />
              </div>

              <div className="mb-4">
                <label className="form-label fw-semibold">
                  Confirm New Password
                </label>
                <input
                  type="password"
                  name="confirmNewPassword"
                  className="form-control"
                  placeholder="Confirm your new password"
                  value={resetFormData.confirmNewPassword}
                  onChange={handleResetChange}
                  required
                />
              </div>

              <div className="d-flex gap-2">
                <button
                  type="submit"
                  className="btn btn-primary w-50"
                  disabled={resetLoading}
                >
                  {resetLoading ? "Resetting..." : "Reset Password"}
                </button>
                <button
                  type="button"
                  className="btn btn-outline-secondary w-50"
                  onClick={toggleResetForm}
                >
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </main>

      {/* Footer */}
      <footer className="text-center py-3 small text-muted">
        © 2025 AI Calling Agent Platform. All rights reserved.
      </footer>
    </div>
  );
};

export default Login;
